import { ReactElement, memo } from 'react';

import { NavigationListItemButtonActionProps } from './types';
import {
  NavigationListItemButtonAccessFeature,
  NavigationListItemButton,
} from './styles';

const NavigationListItemButtonAction = ({
  validSubscriptionFeature,
  ...restProps
}: NavigationListItemButtonActionProps): ReactElement => {
  if (validSubscriptionFeature) {
    return (
      <NavigationListItemButtonAccessFeature
        {...validSubscriptionFeature}
        {...restProps}
        planChipProps={{ gutterRight: false }}
      />
    );
  }

  return <NavigationListItemButton {...restProps} />;
};

export default memo(NavigationListItemButtonAction);
